import { Button } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";

type AskReliHeaderButtonProps = {
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
};

export function AskReliHeaderButton({
  isOpen,
  onClose,
  onOpen,
}: AskReliHeaderButtonProps) {
  const { t } = useTranslation();

  return (
    <div>
      <Button
        variant="ai-outline"
        size="md"
        onClick={() => {
          if (isOpen) {
            onClose();
            return;
          }

          onOpen();
        }}
        data-testid="nav-ask-reli"
        type="button"
        aria-expanded={isOpen}
        aria-haspopup="dialog"
      >
        {t("enterprise.reliability.assistant.title")}
      </Button>
    </div>
  );
}
